export default {
    TAB: 9,
    SHIFT: 16,
    ESC: 27
};
